import {
  billStatus,
  keyBillStatus,
  languagesList,
  renderUserName,
  roles,
  subRoles,
  typeIntervention,
} from "../../../utils/constants";
import { userHasLevel } from "../../../engine/AuthRoute";
import { useDispatch, useSelector } from "react-redux";
import { Button, Space } from "antd";
import { RiMenuSearchLine } from "react-icons/ri";
import { setPagination } from "../Slices/Billing.slice";
import React, { useContext } from "react";
import { BiSearch } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import moment from "moment";
import routes from "../../../engine/routes";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../../engine/context/User.context";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

export const BillsByTypeInputs = ({
  type,
  monthsSelectContent,
  yearsSelectContent,
  loading,
  initSearch,
  initialValuesForm,
  dispatchActionGetBills,
  setSearch,
  advancedSearch,
  setAdvancedSearch,
  formRef,
}) => {
  const { t } = useTranslation();
  const { institutionsFilter, languagesFilter } = useSelector(
    state => state.billing,
  );
  const { configuration } = useContext(UserContext);

  const dispatch = useDispatch();

  const isInstitution = userHasLevel({
    only: {
      [subRoles.institutionAdmin]: "crud",
      [subRoles.institutionFinance]: "crud",
    },
  });

  const inputs = [
    {
      parentLabel: null,
      children: [
        {
          label: t("BillsByTypeInputs.month"),
          dataIndex: "month",
          key: "month",
          name: "month",
          type: "select",
          xl: 4,
          lg: 4,
          md: 4,
          sm: 5,
          xs: 6,
          allowClear: false,
          selectContent: monthsSelectContent,
        },
        {
          label: t("BillsByTypeInputs.year"),
          dataIndex: "year",
          key: "year",
          name: "year",
          value: yearsSelectContent[0].value,
          type: "select",
          xl: 3,
          lg: 3,
          md: 3,
          sm: 5,
          xs: 6,
          allowClear: false,
          selectContent: yearsSelectContent,
        },
        {
          label: t("BillsByTypeInputs.internalNumber"),
          name: "bill_number",
          value: "",
          type: "input",
          capitalize: false,
          xl: 5,
          lg: 5,
          md: 6,
          sm: 7,
          xs: 8,
        },
        {
          visible: userHasLevel({
            not: {
              [roles.institution]: "r",
            },
          }),
          label: t("BillsByTypeInputs.filterByInstitution"),
          name: "institution",
          placeholder: t("BillsByTypeInputs.filterByInstitution"),
          allowClear: true,
          showSearch: true,
          value: [],
          render: () => {},
          type: "select",
          watch: "mandant",
          onChange: async (value, form, r) => {
            formRef.current.setFieldsValue({ mandant: undefined });
          },
          watchValuesCallback: (value, form, r) => {},
          selectContent: [...institutionsFilter[type]]
            .map(e => {
              return {
                ...e,
                label: `${e.label} `,
              };
            })
            .sort((a, b) => a?.label?.localeCompare(b?.label)),
          capitalize: false,
          xl: 6,
          lg: 6,
          md: 6,
          sm: 8,
          xs: 12,
        },
        // {
        //   visible: userHasLevel({
        //     only: {
        //       [roles.admin]: "r",
        //       [roles.permanance]: "r",
        //     },
        //   }),
        //   label: t("BillsByTypeInputs.filterByPrincipal"),
        //   name: "mandant",
        //   watch: "institution",
        //   onChange: async (value, form, r) => {
        //     formRef.current.setFieldsValue({ institution: undefined });
        //   },
        //   watchValuesCallback: (value, form, r) => {},
        //   placeholder: t("BillsByTypeInputs.filterByPrincipal"),
        //   allowClear: true,
        //   showSearch: true,
        //   value: undefined,
        //   render: () => {},
        //   type: "dynamic-select",
        //   endPoint: routes.principals().path,
        //   capitalize: false,
        //   itemCallback: item => {
        //     return {
        //       key: item._id,
        //       label: `${item.name}`,
        //       value: item._id,
        //     };
        //   },
        //   xl: 5,
        //   lg: 4,
        //   md: 6,
        //   sm: 8,
        //   xs: 12,
        // },
        {
          visible:
            userHasLevel({
              only: {
                [roles.admin]: "r",
                [roles.permanance]: "r",
              },
            }) && configuration?.bill?.groupByInterprete,
          label: t("BillsByTypeInputs.filterByInterprete"),
          name: "interprete",
          placeholder: t("BillsByTypeInputs.filterByInterprete"),
          allowClear: true,
          showSearch: true,
          value: undefined,
          render: () => {},
          type: "dynamic-select",
          endPoint: "users?role=interprete",
          capitalize: false,
          itemCallback: item => {
            return {
              key: item._id,
              label: renderUserName(item),
              value: item._id,
            };
          },
          xl: 6,
          lg: 6,
          md: 6,
          sm: 8,
          xs: 12,
        },
        {
          label: t("BillsByTypeInputs.referenceNumber"),
          name: "reference",
          visible: advancedSearch,
          value: "",
          type: "input",
          capitalize: false,
          col: 6,
        },
        {
          label: t("BillsByTypeInputs.serviceNumber"),
          name: "prestation_reference",
          visible: advancedSearch,
          value: "",
          type: "input",
          capitalize: false,
          col: 6,
        },
        {
          label: t("BillsByTypeInputs.languages"),
          dataIndex: "langues",
          key: "langues",
          name: "langues",
          visible: advancedSearch,
          type: "select",
          col: 4,
          allowClear: true,
          selectContent: languagesFilter[type]
            .filter(e => e !== "" && e !== null)
            .map(o => {
              let label = languagesList().find(e => e.value === o).label;
              return { label: label, value: o };
            }),
        },
        {
          label: t("BillsByTypeInputs.status"),
          dataIndex: "status",
          key: "status",
          name: "status",
          visible: advancedSearch,
          type: "select",
          col: 4,
          allowClear: true,
          selectContent: billStatus(t).filter(item => {
            if (isInstitution) {
              return item.value !== keyBillStatus.preparation;
            } else {
              return true;
            }
          }),
        },
        {
          label: t("PrestationsList.inputs.advancedInfoSwitch"),
          visible: advancedSearch,
          name: "advancedCols",
          type: "switch",
          value: false,
          col: 4,
        },
        {
          type: "component",
          style: { textAlign: "left" },
          col: isInstitution ? 12 : 24,
          label: "",
          component: () => {
            return (
              <Space
                align={"center"}
                style={{ width: "100%", justifyContent: "flex-end" }}
              >
                <Button
                  loading={loading}
                  size={"middle"}
                  type={"primary"}
                  style={{
                    marginTop: "-12px",
                    width: "100%",
                    display: "block",
                    fontWeight: "bold",
                  }}
                  icon={<BiSearch style={{ marginTop: "0px" }} size={25} />}
                  onClick={() => dispatchActionGetBills()}
                >
                  {t("BillsByTypeInputs.search")}
                </Button>
                <Button
                  style={{
                    marginTop: "-7px",
                    width: "100%",
                    color: colorPrimary,
                    fontWeight: "bold",
                  }}
                  icon={
                    <GrPowerReset style={{ marginTop: "-3px" }} size={15} />
                  }
                  onClick={async () => {
                    await setSearch(initSearch);

                    formRef.current.resetFields();
                    formRef.current.setFieldsValue(initialValuesForm);
                    await dispatch(
                      setPagination({
                        currentPage: 1,
                        pageSize: 10,
                        sorter: undefined,
                      }),
                    );
                    await dispatchActionGetBills(initSearch);
                  }}
                  size="middle"
                  type={"text"}
                >
                  {t("BillsByTypeInputs.reset")}
                </Button>
                <Button
                  style={{
                    marginTop: "-7px",
                    width: "100%",
                    color: colorPrimary,
                    fontWeight: "bold",
                  }}
                  icon={
                    advancedSearch ? (
                      <FaChevronUp style={{ marginTop: "-3px" }} size={15} />
                    ) : (
                      <FaChevronDown style={{ marginTop: "-3px" }} size={15} />
                    )
                  }
                  onClick={async () => {
                    setAdvancedSearch(!advancedSearch);
                  }}
                  size="middle"
                  type={"text"}
                >
                  {advancedSearch
                    ? t("PrestationsList.inputs.lessFiltersText")
                    : t("PrestationsList.inputs.moreFiltersText")}
                </Button>
              </Space>
            );
          },
        },
      ],
    },
  ];

  return inputs;
};
